module.exports = __webpack_public_path__ + "img/18.0fd15540.jpg";